const WORDS = [
  "Botas de Avestruz",
  "Sombreros Finos",
  "Sillas de Montar",
  "Cinturones Piteados",
  "Talabartería",
  "Camisas Vaqueras",
  "Ropa Western",
  "Hebillas de Autor",
];

export const Marquee = () => {
  const doubled = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      aria-label="Categorías"
      className="relative overflow-hidden py-16 md:py-24 border-y border-[#A66E38]/25 bg-[#0A0908]"
    >
      <div className="marquee-track flex whitespace-nowrap gap-14 will-change-transform">
        {doubled.map((w, i) => (
          <span key={i} className="flex items-center gap-14 shrink-0">
            <span className="font-serif italic text-5xl md:text-7xl lg:text-8xl text-[#F5F0E6] tracking-tight">
              {w}
            </span>
            <span
              className="text-[#C89B3C] text-3xl md:text-5xl"
              aria-hidden="true"
            >
              ✦
            </span>
          </span>
        ))}
      </div>
    </section>
  );
};
